module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-king.e7b75fb8.svg";